import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import axios from 'axios';
import config from './config';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import AppRoutes from './AppRoutes'; // Import AppRoutes
import Spinner from './components/Spinner'; // Optional loading spinner

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // For showing a loading spinner while checking auth status
  const [userRole, setUserRole] = useState(null); // Store user role for role-specific logic

  const checkAuthStatus = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiBaseUrl}/auth/me`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setIsAuthenticated(true);
      setUserRole(response.data.role); // Assuming the API returns a user role
    } catch (error) {
      console.error('Error checking authentication:', error);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
    checkAuthStatus();
  };

  const handleLogout = () => {
    localStorage.removeItem('token'); // Clear token from local storage
    setIsAuthenticated(false);
    setUserRole(null);
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  if (loading) {
    return <Spinner />; // Display a spinner while checking authentication
  }

  return (
    <Router>
      <div className="container-scroller">
        {isAuthenticated && (
          <>
            <Header onLogout={handleLogout} />
            <div className="container-fluid page-body-wrapper">
              <Sidebar userRole={userRole} /> {/* Pass userRole to Sidebar */}
              <div className="main-panel">
                <AppRoutes
                  isAuthenticated={isAuthenticated}
                  onLogin={handleLogin}
                  onLogout={handleLogout}
                />
                <Footer />
              </div>
            </div>
          </>
        )}
        {!isAuthenticated && (
          <AppRoutes
            isAuthenticated={isAuthenticated}
            onLogin={handleLogin}
            onLogout={handleLogout}
          />
        )}
      </div>
    </Router>
  );
}

export default App;
